import {AttendanceRoundingItem} from "types/settings/general-setting"
import RoundingRange from "./RoundingRange"
import {Icon, SecondaryButton} from "components"
import ButtonCheckbox from "components/buttons/buttonCheckbox"
import styles from "./RoundingTables.module.css"
import {IconButton} from "components/ui"
import CampusSelect from "components/CampusSelect"

type RoundingTablesProps = {
    attendanceRoundingTables: Array<{
        roundingTableId: number | string
        isAppliedAllCampus: boolean
        campuses: number[]
        attendanceRoundingRanges: Array<AttendanceRoundingItem>
    }>
    setAttendanceRoundingTable: (payload: {
        roundingTableId: number | string
        attendanceRoundingRanges: any[]
        isAppliedAllCampus: boolean
        campuses: any[]
    }) => void
    addNewAttendanceRoundingTable: () => void
    removeAttendanceRoundingTable: (roundingTableId: number | string) => void
}

const RoundingTables = (props: RoundingTablesProps) => {
    const {
        attendanceRoundingTables,
        setAttendanceRoundingTable,
        addNewAttendanceRoundingTable,
        removeAttendanceRoundingTable
    } = props

    return (
        <>
            {attendanceRoundingTables.map((attendanceRoundingTable) => {
                const attendanceRoundingRanges = attendanceRoundingTable.attendanceRoundingRanges ?? []

                return (
                    <div key={attendanceRoundingTable.roundingTableId} className={styles.roundingTableContainer}>
                        <div className={styles.headerButton}>
                            <div className={styles.leftHeader}>
                                <div
                                    onClick={() => {
                                        setAttendanceRoundingTable({
                                            ...attendanceRoundingTable,
                                            isAppliedAllCampus: !attendanceRoundingTable.isAppliedAllCampus
                                        })
                                    }}
                                    className={styles.checkboxContainer}
                                    style={{minWidth: "210px"}}>
                                    <ButtonCheckbox
                                        id={`rounding_apply_campus`}
                                        name={"APPLY ALL CAMPUSES"}
                                        allChecked={!!attendanceRoundingTable.isAppliedAllCampus}
                                        onClick={() => {
                                            setAttendanceRoundingTable({
                                                ...attendanceRoundingTable,
                                                isAppliedAllCampus: !attendanceRoundingTable.isAppliedAllCampus
                                            })
                                        }}
                                    />
                                    <span className={styles.titleApplyAllCampuses}>Apply All Campuses</span>
                                </div>
                                <div className={styles.campusSelect}>
                                    <CampusSelect
                                        isMulti
                                        isClearable
                                        readOnly={!!attendanceRoundingTable.isAppliedAllCampus}
                                        isDisabled={!!attendanceRoundingTable.isAppliedAllCampus}
                                        placeholder="Campuses"
                                        value={attendanceRoundingTable?.campuses ?? []}
                                        onChange={(newValue) =>
                                            setAttendanceRoundingTable({
                                                ...attendanceRoundingTable,
                                                campuses: newValue ?? []
                                            })
                                        }
                                    />
                                </div>
                            </div>

                            <SecondaryButton
                                title={"DELETE"}
                                color="var(--error-400-base)"
                                className={styles.deleteButton}
                                onClick={() => removeAttendanceRoundingTable(attendanceRoundingTable.roundingTableId)}
                                icon={
                                    <Icon color={"var(--error-400-base)"} icon="DELETE" className={styles.deleteIcon} />
                                }
                            />
                        </div>

                        <RoundingRange
                            listData={attendanceRoundingRanges}
                            setListData={(payload) => {
                                setAttendanceRoundingTable({
                                    ...attendanceRoundingTable,
                                    attendanceRoundingRanges: payload
                                })
                            }}
                        />
                    </div>
                )
            })}

            <div className={styles.buttonAddMore}>
                <SecondaryButton title={"ADD MORE"} onClick={addNewAttendanceRoundingTable} />
            </div>
        </>
    )
}

export default RoundingTables
